enum SolanaNetworkHealth {
  Down = "Down",
  Good = "Good",
  Slow = "Slow",
  Unknown = "Unknown",
}

export default SolanaNetworkHealth;
